/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gt_Powered_ByInputs */

const en_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered By`)
};

const ar_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شُغِّل بواسطة`)
};

const bn_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাওয়ার্ড বাই`)
};

const de_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützt von`)
};

const es_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollado con`)
};

const fr_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propulsé par`)
};

const pt_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvido com`)
};

const zh_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术支持`)
};

const tr_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destekleyen`)
};

const ru_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При поддержке`)
};

const pl_gt_powered_by = /** @type {(inputs: Gt_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługiwane przez`)
};

/**
* | output |
* | --- |
* | "Powered By" |
*
* @param {Gt_Powered_ByInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const gt_powered_by = /** @type {((inputs?: Gt_Powered_ByInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gt_Powered_ByInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_gt_powered_by(inputs)
	if (locale === "bn") return bn_gt_powered_by(inputs)
	if (locale === "de") return de_gt_powered_by(inputs)
	if (locale === "es") return es_gt_powered_by(inputs)
	if (locale === "fr") return fr_gt_powered_by(inputs)
	if (locale === "pt") return pt_gt_powered_by(inputs)
	if (locale === "zh") return zh_gt_powered_by(inputs)
	if (locale === "tr") return tr_gt_powered_by(inputs)
	if (locale === "ru") return ru_gt_powered_by(inputs)
	if (locale === "pl") return pl_gt_powered_by(inputs)
	return en_gt_powered_by(inputs)
});